import { extractIntegrationConfigurations } from './integrationConfigurationUtils';
import { IntegrationConfig } from './integrationTypes';

export const INTEGRATION_CONFIG_PAYMENT_PROVIDER_ALLOW_OWNER_ACCOUNT = 'allowOwnerDifferentAccount';
export const INTEGRATION_CONFIG_PAYMENT_PROVIDER_DEFAULT_FOR_NEW_LEASES = 'activateForAllNewLeases';

// Prefix of the Stripe payout statement descriptor (e.g. `U2R-ABC123 TO 6352`). Written on payout
// creation, matched on reconciliation, and used to recognize payout transactions in the UI.
export const PAYOUT_STATEMENT_DESCRIPTOR_PREFIX = 'U2R-';

export const BANK_ACCOUNT_LAST_DIGITS = 4;

type PaymentProviderConfig = IntegrationConfig<'ALLOW_OWNER_DIFFERENT_ACCOUNT' | 'ACTIVATE_FOR_ALL_NEW_LEASES'>;

export const INTEGRATION_CONFIG_PAYMENT_PROVIDER: PaymentProviderConfig = {
  ALLOW_OWNER_DIFFERENT_ACCOUNT: {
    name: INTEGRATION_CONFIG_PAYMENT_PROVIDER_ALLOW_OWNER_ACCOUNT,
    defaultValue: 'false',
  },
  ACTIVATE_FOR_ALL_NEW_LEASES: {
    name: INTEGRATION_CONFIG_PAYMENT_PROVIDER_DEFAULT_FOR_NEW_LEASES,
    defaultValue: 'false',
  },
};

export const PAYMENT_PROVIDER_DEFAULT_CONFIGURATIONS = extractIntegrationConfigurations(
  INTEGRATION_CONFIG_PAYMENT_PROVIDER
);
